import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { RouterService } from '@nimbus-library/features/navigation/router.service';
import { ModalService } from '@nimbus-library/features/modal/services/modal.service';
import { TranslationObserverService } from '@nimbus-library/features/localization/services/translation-observer.service';
import { LocalizationActions } from '@nimbus-library/features/localization/store/localization.action';
import { IMicrosoftTeamsContextAccessor } from '@nimbus-library/features/microsoft-teams/contract/i-microsoft-teams-context.accessor';
import { IInitializationService } from '@nimbus-portal/features/initialization/i-initialization.service';
import { WallboardPermissionManagerService } from './wallboard-permission-manager.service';

@Injectable({ providedIn: 'root' })
export class WallboardInitializationService extends IInitializationService {
  public constructor(
    store: Store,
    routerService: RouterService,
    teamsService: IMicrosoftTeamsContextAccessor,
    modalService: ModalService,
    translateObserverService: TranslationObserverService,
    private readonly wallboardPermissionManagerService: WallboardPermissionManagerService,
  ) {
    super(store, routerService, teamsService, modalService, translateObserverService);
  }

  public async initialize(): Promise<Subscription> {
    this.wallboardPermissionManagerService.initialize();
    this.store.dispatch(new LocalizationActions.LoadLanguage());
    this.store.dispatch(new LocalizationActions.LoadDateFormat());

    const subscription$ = new Subscription();
    subscription$.add(this.startTrackThemeChanges());
    subscription$.add(this.startTranslations());
    return subscription$;
  }
}
